import React from "react";

const TermsOfService: React.FC = () => (
  <div className="page-container max-960">
    <div className="card">
      <h1>Terms of Service & Privacy Policy</h1>
      <ul>
        <li>
          <a target="_blank" href="https://s3.amazonaws.com/hc-static/pdfs/applicant-terms.pdf" rel="noreferrer">
              Terms of Service for Applicants
          </a>
        </li>
        <li>
          <a target="_blank" href="https://s3.amazonaws.com/hc-static/pdfs/manager-terms.pdf" rel="noreferrer">
              Terms of Service for Property Managers
          </a>
        </li>
        <li>
          <a target="_blank" href="https://s3.amazonaws.com/hc-static/pdfs/privacy-policy.pdf" rel="noreferrer">
              Privacy Policy
          </a>
        </li>
      </ul>
    </div>
  </div>
);

export default TermsOfService;
